// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jobbutton {
    display: block;
    padding: 15px;
    font-size: 25px;
    font-weight: normal;
    color: #fff;
    border: none;
    border-radius: 10px;
    text-decoration: none;
    margin: 10px 0;
    text-transform: none;
    background-color: #e48f2d;
}`, "",{"version":3,"sources":["webpack://./src/components/jobs/jobportal/Jobportal.css"],"names":[],"mappings":"AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;IACpB,yBAAyB;AAC7B","sourcesContent":["@import url('https://fonts.googleapis.com/icon?family=Material+Icons');\n\n.jobbutton {\n    display: block;\n    padding: 15px;\n    font-size: 25px;\n    font-weight: normal;\n    color: #fff;\n    border: none;\n    border-radius: 10px;\n    text-decoration: none;\n    margin: 10px 0;\n    text-transform: none;\n    background-color: #e48f2d;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
